// Base filter implementation that defines basic functionality for interface
// eslint-disable-next-line
class FilterBase {
  #key;

  #getter;

  constructor({ key, getter = (datum) => datum[this.key()] }) {
    this.#key = key;
    this.#getter = getter;
  }

  // Return true or false depending on if our <datum> matches the parameters
  // for the filter
  // eslint-disable-next-line
  filter() {
    return true;
  }

  // Convert our 'search token' into a human readable string
  // By default it's undefined.
  // eslint-disable-next-line
  stringify() {
    return '<UNDEFINED>';
  }

  // Get the value we're checking against from the datum's fields.
  getValue(datum) {
    return this.#getter(datum);
  }

  key() {
    return this.#key;
  }
}

export class RangeFilter extends FilterBase {
  minimum;

  maximum;

  constructor({ key, getter, minimum = undefined, maximum = undefined }) {
    super({ key, getter });
    this.minimum = minimum;
    this.maximum = maximum;
  }

  filter(datum) {
    const value = this.getValue(datum);
    if (Number.isNaN(value)) return false;
    if (this.minimum !== undefined && value < this.minimum) return false;
    if (this.maximum !== undefined && value > this.maximum) return false;
    return true;
  }

  stringify() {
    if (this.minimum !== undefined && this.maximum !== undefined)
      return `${this.key()} ≥ ${this.minimum} and ≤ ${this.maximum}`;
    if (this.minimum !== undefined) return `${this.key()} ≥ ${this.minimum}`;
    if (this.maximum !== undefined) return `${this.key()} ≤ ${this.maximum}`;
    return '<ANOMALOUS>';
  }
}

export class ContainsStatusFilter extends FilterBase {
  fragment = [];

  constructor({ key, getter, fragment }) {
    super({ key, getter });
    this.fragment = fragment;
  }

  // Problem: We need columndef formatted data here
  // filter(datum) {
  //   const value = this.getValue(datum);
  // }

  stringify() {
    return this.fragment;
  }
}

export class ContainsTextFilter extends FilterBase {
  fragment = '';

  constructor({ key, getter, fragment }) {
    super({ key, getter });
    this.fragment = fragment;
  }

  filter(datum) {
    const value = this.getValue(datum);
    const fragment = this.fragment.toLowerCase();
    return value === fragment || (value && value.toLowerCase().includes(fragment));
  }

  stringify() {
    return this.fragment;
  }
}

export class PointTypeFilter extends FilterBase {
  type = undefined;

  constructor({ key, getter, type }) {
    super({ key, getter });
    this.type = type;
  }

  filter(datum) {
    const pointType = this.getValue(datum);
    const { type } = this;
    return pointType === type.id;
  }

  stringify() {
    return this.type;
  }
}

export class EquipmentTypeFilter extends FilterBase {
  type = undefined;

  constructor({ key, getter, type }) {
    super({ key, getter });
    this.type = type;
  }

  filter(datum) {
    const equipTypeStr = this.getValue(datum);
    const { type } = this;
    return equipTypeStr === type;
  }

  stringify() {
    return this.type;
  }
}
